module.exports = __webpack_public_path__ + "img/4.8b58db6a.png";